export default __webpack_public_path__ + "static/media/vas-image.221e87f4.svg";